export function convertNameToApiName(name: string) {
    return name
        .trim()
        .toLowerCase()
        .replace(/\s+/g, '_')
        .replace(/[^a-zA-Z0-9_-]/g, '')
}

export function getUniqueApiName(name: string, existingApiNames: string[]): string {
    const existingApiNamesSet = new Set(existingApiNames)
    const apiName = convertNameToApiName(name)

    let effectiveApiName = apiName
    let i = 1
    while (existingApiNamesSet.has(effectiveApiName)) {
        effectiveApiName = `${apiName}_${i}`
        i++
    }

    return effectiveApiName
}
